import { BUILT_IN_PROFILES, createProfile } from "../profiles/index.js";
import { importProfile } from "../storage.js";
import { state, openForEditing, startUnsaved, takenIds, takenNames, deleteCustomProfile } from "../state.js";
import { el, actionButton, announce } from "../ui/dom.js";
import { confirmAction, newProfileDialog, showMessages } from "../ui/dialogs.js";

export function mount(root, route, nav) {
  const editHash = (profile) => `#/profiles/${encodeURIComponent(profile.id)}`;

  function edit(profile) {
    openForEditing(profile);
    state.previewSource = state.doc ? "document" : "sample";
    state.editingFromResult = false;
    nav.go(editHash(profile));
  }

  async function remove(profile) {
    const ok = await confirmAction("Delete profile?", `“${profile.name}” will be removed from this browser. Download it first if you might want it again.`, "Delete profile");
    if (!ok) return;
    try {
      deleteCustomProfile(profile.id);
      announce(`${profile.name} deleted.`);
      nav.go("#/profiles");
    } catch (error) {
      showMessages("Couldn't delete", [error.message]);
    }
  }

  async function create() {
    const answer = await newProfileDialog({ builtIns: BUILT_IN_PROFILES, takenNames: takenNames() });
    if (!answer) return;
    const profile = createProfile(answer.name, answer.startFrom, takenIds());
    startUnsaved(profile);
    state.previewSource = state.doc ? "document" : "sample";
    state.editingFromResult = false;
    nav.go(editHash(profile));
  }

  const importInput = el("input", { type: "file", accept: ".json,application/json", class: "sr-only", tabindex: "-1", "aria-hidden": "true" });
  importInput.addEventListener("change", async () => {
    const file = importInput.files[0];
    importInput.value = "";
    if (!file) return;
    const { profile, errors } = importProfile(await file.text(), takenIds());
    if (!profile) {
      showMessages("Couldn't import that profile", errors);
      return;
    }
    startUnsaved(profile);
    state.editingFromResult = false;
    nav.go(editHash(profile));
    if (errors.length) showMessages("Imported, with some problems", errors);
  });

  const list = (profiles, saved) => el("ul", { class: "profile-list" }, profiles.map((p) =>
    el("li", { class: "profile-item glass" },
      el("div", {}, el("h3", {}, p.name), el("p", { class: "hint" }, p.description || "No description.")),
      el("div", { class: "row" },
        actionButton("Edit", p.name, { onclick: () => edit(p) }),
        saved ? actionButton("Delete", p.name, { class: "danger-btn", onclick: () => remove(p) }) : null))));

  root.append(el("section", { class: "editor-page" },
    el("h1", {}, "Profiles"),
    el("p", {}, "A profile decides which HTML each Word style becomes, and which stylesheet the result uses."),
    el("div", { class: "row" },
      actionButton("New profile", "", { class: "primary-btn", onclick: create }),
      actionButton("Import", "a profile file (.json)", { onclick: () => importInput.click() }),
      importInput),
    el("h2", {}, "Your saved profiles"),
    state.customs.length ? list(state.customs, true) : el("p", { class: "hint" }, "You haven't saved any profiles in this browser yet."),
    el("h2", {}, "Built-in profiles"),
    el("p", { class: "hint" }, "Built-in profiles can't be changed. Editing one creates your own copy."),
    list(BUILT_IN_PROFILES, false)));
  return { title: "Profiles" };
}
